// @ts-ignore
import type * as SchemaTypes from '../../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { NonSkuLabGrownFragmentDoc } from '../../../../graphql/api/stone/nonsku/fragments/nonSkuLabGrown.fragment.generated';
import { NonSkuLabGrownDiamondBoundsFragmentDoc } from '../../../../graphql/api/stone/nonsku/fragments/nonSkuLabGrownDiamondBounds.fragment.generated';
import { ProductPageListingFragmentDoc } from '../../../../graphql/api/cms/pageProductListing.fragment.generated';
import * as Urql from '@urql/vue';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;

export const LabGrownSearchDocument = gql`
    query labGrownSearch($filters: NonSkuLabGrownDiamondsFilters!, $sort: NonSkuLabGrownDiamondSortInput!, $currency: CurrencyInput!, $region: RegionCode!, $locale: Locale!, $contentPath: String!) {
  nonSkuLabGrownDiamonds(
    region: $region
    currency: $currency
    filters: $filters
    sort: $sort
  ) {
    ...nonSkuLabGrown
  }
  nonSkuLabGrownDiamondsBounds {
    ...nonSkuLabGrownDiamondBounds
  }
  pageProductListing(path: $contentPath, locale: $locale) {
    ...productPageListing
  }
}
    ${NonSkuLabGrownFragmentDoc}
${NonSkuLabGrownDiamondBoundsFragmentDoc}
${ProductPageListingFragmentDoc}`;

export function useLabGrownSearchQuery(options?: Omit<Urql.UseQueryArgs<never, SchemaTypes.LabGrownSearchQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<SchemaTypes.LabGrownSearchQuery, SchemaTypes.LabGrownSearchQueryVariables | undefined>({ query: LabGrownSearchDocument, variables: undefined, ...options });
};